<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Edit Template
                    </div>
                    <div class="card-block">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label class="vcentered-text">Contract name *</label>
                                    <input type="text" class="form-control" :class="errors.contract_name ? 'error-class': ''" v-model="edit_template.contract_name" placeholder="Enter contract name" :disabled="edit_template.contract_status == 'done'"/>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="vcentered-text">Contract number</label>
                                    <input type="text" class="form-control" v-model="edit_template.contract_number" placeholder="Enter contract number" :disabled="edit_template.contract_status == 'done'"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label class="vcentered-text">Place of signing contract</label>
                                    <input type="text" class="form-control" v-model="edit_template.contract_place" placeholder="Enter place" :disabled="edit_template.contract_status == 'done'"/>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="vcentered-text">Contract date</label>
                                    <datepicker placeholder="yyyy-mm-dd" :disabled="edit_template.contract_status == 'done'" input-class="edit-template-date-picker" v-model="edit_template.contract_date" format="yyyy-MM-dd"></datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label class="vcentered-text">Apply person</label>
                                    <input type="text" class="form-control" v-model="edit_template.apply_person" placeholder="Enter person" :disabled="edit_template.contract_status == 'done'"/>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="vcentered-text">Apply position</label>
                                    <input type="text" class="form-control" v-model="edit_template.apply_position" placeholder="Enter position" :disabled="edit_template.contract_status == 'done'"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 z-1">
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label class="vcentered-text">Choose client *</label>
                                    <autocomplete :items="items"
                                                  :item="item" v-model="item"
                                                  :min-len="0" :get-label="getLabel"
                                                  :component-item='template'
                                                  :input-attrs="{
                                                    name: 'input-test',
                                                    disabled: edit_template.contract_status == 'done' ? true : false,
                                                    class: edit_template.contract_status == 'done' ? 'v-autocomplete-input-disabled' : 'v-autocomplete-input'
                                                  }"
                                                  @update-items="updateItems">
                                    </autocomplete>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="vcentered-text">Payment due date</label>
                                    <input type="number" class="form-control" v-model="edit_template.payment_due_date" :disabled="edit_template.contract_status == 'done'" placeholder="Enter number"/>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="col-md-12 z-0">
                            <div class="row">
                                <div class="col-md-6 text-left">
                                    <label style="font-size: 18px; padding-top: 4px;">Variables</label>
                                </div>
                                <div class="col-md-6 text-right">
                                    <button class="btn dg-btn--ok" @click="isCollapsed = !isCollapsed">Show/Hide</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="isCollapsed">
                            <div class="row">
                                <div class="col-md-6 mt-1">
                                    <div class="row">
                                        <div class="col-md-12 mt-1" v-show="edit_template.defined_variables.length">
                                            <draggable :list="edit_template.defined_variables" @start="drag=true" @end="drag=false" :element="'div'" :options="{animation:50, handle:'.variables-drag', ghostClass: 'ghost'}" @change="updateVariablesList()">
                                                <div class="row" v-for="(variable, index) in edit_template.defined_variables">
                                                    <div class="col-md-1 form-group text-left" v-if="edit_template.contract_status != 'done'">
                                                        <i class="variables-drag fa fa-arrows-v fa-lg action" aria-hidden="true" rel="tooltip" title="Drag and drop" style="margin-top: 10px;"></i>
                                                    </div>
                                                    <div class="col-md-5 form-group">
                                                        <input type="text" class="form-control" v-model="variable.name" placeholder="Enter variable name" :disabled="edit_template.contract_status == 'done'"/>
                                                    </div>
                                                    <div class="col-md-5 form-group">
                                                        <input type="text" class="form-control" v-model="variable.value" placeholder="Enter variable text" :disabled="edit_template.contract_status == 'done'"/>
                                                    </div>
                                                    <div class="col-md-1 form-group text-left" v-if="edit_template.contract_status != 'done'">
                                                        <i class="fa fa-remove fa-lg action" @click="removeVariable(variable)" aria-hidden="true" rel="tooltip" title="Delete variable" style="margin-top: 10px; margin-left: -15px;"></i>
                                                    </div>
                                                </div>
                                            </draggable>
                                        </div>
                                    </div>
                                    <div class="row" v-if="edit_template.contract_status != 'done'">
                                        <div class="pull-right col-md-12">
                                            <div class="col-md-5 pull-right text-right">
                                                <button class="btn dg-btn--cancel" @click="addVariable()">Add variable</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 mt-1">
                                    <all-variables :default-variables="edit_template.default_variables" :fixed-variables="edit_template.fixed_variables"></all-variables>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6 text-left">
                                    <label style="font-size: 18px; padding-top: 4px;">Calculations</label>
                                </div>
                                <div class="col-md-6 text-right">
                                    <button class="btn dg-btn--ok" @click="calculations_collapsed = !calculations_collapsed">Show/Hide</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="calculations_collapsed">
                            <calculations-variables></calculations-variables>
                            <div class="row">
                                <div class="col-md-12">
                                    <table class="table table-bordered table-condensed mt-1">
                                        <thead>
                                        <tr>
                                            <th style="width: 5%;">Main</th>
                                            <th style="width: 25%;">Name</th>
                                            <th style="width: 35%;">Description</th>
                                            <th style="width: 10%;">Quantity</th>
                                            <th style="width: 10%;">Unit</th>
                                            <th style="width: 10%;">Price</th>
                                            <th style="width: 5%;">Options</th>
                                        </tr>
                                        </thead>
                                        <!--<tbody>-->
                                        <draggable :list="edit_template.calculations_table" @start="drag=true" @end="drag=false" :element="'tbody'" :options="{animation:50, handle:'.calculations-drag', ghostClass: 'ghost'}" @change="updateCalculationsList()">
                                            <tr :class="row.main ? 'calculationsTableMainRow' : 'calculationsTableRow'" v-if="edit_template.calculations_table.length" v-for="(row, index) in edit_template.calculations_table">
                                                <td><input type="checkbox" :disabled="edit_template.contract_status == 'done'" v-model="row.main" :checked = "row.main"/></td>
                                                <td><input type="text" :disabled="edit_template.contract_status == 'done'" class="form-control" v-model="row.name"/></td>
                                                <td><textarea rows="1" cols="50" :disabled="edit_template.contract_status == 'done'" class="form-control" v-model="row.description"/></td>
                                                <td><input type="number" :disabled="row.main || edit_template.contract_status == 'done'" class="form-control" v-model="row.quantity"/></td>
                                                <td><input type="text" :disabled="row.main || edit_template.contract_status == 'done'" class="form-control" v-model="row.unit"/></td>
                                                <td><input type="number" :disabled="row.main || edit_template.contract_status == 'done'" class="form-control" v-model="row.price"/></td>
                                                <td>
                                                    <i v-if="edit_template.contract_status != 'done'" class="fa fa-remove fa-lg action" @click="removeCalculation(row)" aria-hidden="true" rel="tooltip" title="Delete calculation"></i>
                                                    <i v-if="edit_template.contract_status != 'done'" class="calculations-drag fa fa-arrows-v fa-lg action" aria-hidden="true" rel="tooltip" title="Drag and drop" style="margin-top: 10px;"></i>
                                                </td>
                                            </tr>
                                            <!--</tbody>-->
                                        </draggable>
                                        <tr class="calculationsTableMainRow">
                                            <td colspan="5" class="text-right"><label>Total quantity sum</label></td>
                                            <td colspan="2"><input v-model="calculations.quantity_sum" disabled class="form-control" type="number"/></td>
                                        </tr>
                                        <tr class="calculationsTableMainRow">
                                            <td colspan="5">
                                                <div class="row flex">
                                                    <div class="col-md-3 text-left flex">
                                                        <input type="checkbox" :checked="edit_template.vat_enabled" v-model="edit_template.vat_enabled">
                                                        <label>VAT enabled</label>
                                                    </div>
                                                    <div class="col-md-9 text-right"><label>Total price without VAT</label></div>
                                                </div>
                                            </td>
                                            <td colspan="2"><input v-model="calculations.price_without_vat" disabled class="form-control" type="number"/></td>
                                        </tr>
                                        <tr class="calculationsTableMainRow">
                                            <td colspan="5">
                                                <input type="checkbox" :checked="edit_template.advance_payment_enabled" v-model="edit_template.advance_payment_enabled">
                                                <label>Advance payment</label>
                                            </td>
                                            <td colspan="2"><input v-model="edit_template.paid_advance_payment" :disabled="!edit_template.advance_payment_enabled" class="form-control" type="number"/></td>
                                        </tr>
                                        <tr class="calculationsTableMainRow">
                                            <td colspan="3">
                                                <input type="checkbox" :checked="edit_template.discount_enabled" v-model="edit_template.discount_enabled">
                                                <label>Discount</label>
                                            </td>
                                            <td colspan="2"><input v-model="edit_template.discount_percentage" :disabled="!edit_template.discount_enabled" class="form-control" type="text"/></td>
                                            <td colspan="2"><input v-model="edit_template.discount_amount" :disabled="!edit_template.discount_enabled" class="form-control" type="number"/></td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-12 text-right" v-if="edit_template.contract_status != 'done'">
                                    <!--<div class="col-md-5 pull-right text-right">-->
                                    <button class="btn dg-btn--cancel" @click="addCalculation()">Add calculation</button>
                                    <!--</div>-->
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <ckeditor v-model="editor_content" :disabled="edit_template.contract_status == 'done'"></ckeditor>
                            </div>
                            <!--<div class="col-md-12">-->
                                <!--<div class="row">-->
                                    <!--<div class="col-md-6">-->
                                        <!--<table class="table table-bordered table-striped table-condensed mt-1">-->
                                            <!--<thead>-->
                                            <!--<tr>-->
                                                <!--<th>File name</th>-->
                                                <!--<th>File type</th>-->
                                                <!--<th>Options</th>-->
                                            <!--</tr>-->
                                            <!--</thead>-->
                                            <!--<tbody>-->
                                            <!--<tr v-if="contract_files.length && file.file_type != 'contract'" v-for="file in contract_files">-->
                                                <!--<td>{{file.file_name}}</td>-->
                                                <!--<td>{{file.file_type}}</td>-->
                                                <!--<td>-->
                                                    <!--<form v-if="file.file_type != 'contract'" style="display: inline;" action="/print_appendix" target="_blank">-->
                                                        <!--<input type="hidden" name="file_id" :value="file.id">-->
                                                        <!--<button style="border: none; background-color: inherit;" type="submit" class=" fa fa-file-pdf-o fa-lg action" rel="tooltip" title="Download file"></button>-->
                                                    <!--</form>-->
                                                    <!--<i class="fa fa-trash fa-lg action" @click="deleteFile(file)" rel="tooltip" title="Delete file"></i>-->
                                                <!--</td>-->
                                            <!--</tr>-->
                                            <!--</tbody>-->
                                        <!--</table>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="col-md-12">-->
                                <!--<div class="upload">-->
                                    <!--<ul>-->
                                        <!--<li v-for="(file, index) in files" :key="file.id">-->
                                            <!--<span>{{file.name}}</span> - -->
                                            <!--<span>{{file.size}}</span> - -->
                                            <!--<span v-if="file.error">{{file.error}}</span>-->
                                            <!--<span v-else-if="file.success">success</span>-->
                                            <!--<span v-else-if="file.active">active</span>-->
                                            <!--<span v-else-if="file.active">active</span>-->
                                            <!--<span v-else></span>-->
                                        <!--</li>-->
                                    <!--</ul>-->
                                    <!--<div class="example-btn">-->
                                        <!--<file-upload-->
                                                <!--class="btn btn-primary"-->
                                                <!--:post-action= url-->
                                                <!--:multiple="true"-->
                                                <!--v-model="files"-->
                                                <!--ref="upload">-->
                                            <!--<i class="fa fa-plus"></i>-->
                                            <!--Select files-->
                                        <!--</file-upload>-->
                                        <!--<label class="btn file-uploads file-uploads-html5">-->
                                            <!--<button type="button" class="btn btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">-->
                                                <!--<i class="fa fa-arrow-up" aria-hidden="true"></i>-->
                                                <!--Start Upload-->
                                            <!--</button>-->
                                            <!--<button type="button" class="btn btn-danger"  v-else @click.prevent="$refs.upload.active = false">-->
                                                <!--<i class="fa fa-stop" aria-hidden="true"></i>-->
                                                <!--Stop Upload-->
                                            <!--</button>-->
                                        <!--</label>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <div class="col-md-12 mt-1">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="switch switch-text switch-primary">
                                            <input type="checkbox" v-model="edit_template.footer" :disabled="edit_template.contract_status == 'done'" class="switch-input" checked>
                                            <span class="switch-label" data-on="On" data-off="Off"></span>
                                            <span class="switch-handle"></span>
                                        </label>
                                        <label class="footer-switch">Add footer to contract</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mt-1">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="switch switch-text switch-primary">
                                            <input type="checkbox" v-model="edit_template.advanced_invoice" class="switch-input">
                                            <span class="switch-label" data-on="Yes" data-off="No"></span>
                                            <span class="switch-handle"></span>
                                        </label>
                                        <label class="footer-switch">Advance payment request</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mt-1">
                                <div class="row">
                                    <div class="col-md-3 form-group">
                                        <select class="form-control" v-model="edit_template.document_type" :disabled="edit_template.contract_status == 'done'">
                                            <option v-for="type in document_type" :value="type.value">{{type.name}}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <select class="form-control" v-model="edit_template.contract_status" :disabled="(edit_template.contract_status == 'done' && !contract_editable && !permission_change_done_status)">
                                            <option v-for="status in statuses" :value="status.value">{{status.name}}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-6">
                                        <button v-if="contract_editable || permission_change_done_status" class="btn dg-btn--ok" @click="updateTemplate()">Update</button>

                                        <button v-if="contract_saved || !contract_editable" style="border: none; background-color: inherit;" class="fa fa-file-pdf-o fa-lg action"
                                          title="Print contract PDF" @click="download({newTab:true, url:'/api/print_template', params:{template_id:edit_template.contract_id}})"></button>

                                        <button v-if="contract_saved || !contract_editable" style="border: none; background-color: inherit;" class="fa fa-file-word-o fa-lg action"
                                          title="Print contract Docx" @click="download({url:'/api/print_template_to_msword', params:{template_id:edit_template.contract_id}})"></button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Ckeditor from 'vue-ckeditor2';
import { mapGetters, mapActions } from 'vuex';
import modal from 'vue-strap/src/Modal';
// import Backend from 'Backend';
import FileUpload from 'vue-upload-component';
import VueNotifications from 'vue-notifications';
import draggable from 'vuedraggable';
import Autocomplete from 'v-autocomplete';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import CalculationsVariables from './CalculationsVariables.vue';
import AllVariables from './AllVariables.vue';
import ClientsAutocompleteDropdownItem from './ClientsAutocompleteDropdownItem.vue';
import { Backend, download, filenameFilter } from '@/_axios';

export default {
  name: 'EditTemplate',
  components: {
    modal,
    FileUpload,
    draggable,
    Ckeditor,
    CalculationsVariables,
    AllVariables,
    Autocomplete,
    Datepicker
  },
  data() {
    return {
      download: download,
      filenameFilter: filenameFilter,
      item: '',
      items: [],
      template: ClientsAutocompleteDropdownItem,
      statuses: [
        {
          name: 'Draft',
          value: 'draft'
        },
        {
          name: 'Sent to client',
          value: 'sent_to_client'
        },
        {
          name: 'Review',
          value: 'in_review'
        },
        {
          name: 'Done',
          value: 'done'
        }
      ],
      document_type: [
        {
          name: 'Main contract',
          value: 'main_contract'
        },
        {
          name: 'Agreement protocol',
          value: 'agreement_protocol'
        },
        {
          name: 'Invoice',
          value: 'invoice'
        },
        {
          name: 'Document form',
          value: 'document_form'
        },
        {
          name: 'Acceptance act with invoice',
          value: 'acceptance_act_and_invoice'
        },
        {
          name: 'Appendix',
          value: 'appendix',
        },
        {
          name: 'Proposal for client',
          value: 'proposal_for_client'
        },
        {
          name: 'Acceptance act',
          value: 'acceptance_act'
        }
      ],
      files: [],
      url: '',
      editor_content: '',
      errors: false,
      edit_template: {
        contract_id: '',
        contract_name: '',
        contract_number: '',
        variables: [],
        contract_content: '',
        client_id: '',
        contract_place: '',
        contract_date: '',
        contract_status: '',
        apply_person: '',
        apply_position: '',
        document_type: '',
        footer: '',
        payment_due_date: '',
        paid_advance_payment: 0,
        advance_payment_enabled: false,
        discount_enabled: false,
        discount_percentage: 'Discount (X%)',
        discount_amount: 0,
        calculations_table: [],
        defined_variables: [],
        fixed_variables: [],
        default_variables: [],
        contract_type: '',
        vat_enabled: true,
        advanced_invoice: false,
      },
      contract_files: [],
      contract_saved: false,
      contract_editable: true,
      contract_updated: false,
      permission_change_done_status: false,
      calculations: {
        quantity_sum: 0,
        price_without_vat: 0
      },
      confirmation_options: {
        okText: 'Delete',
        cancelText: 'Cancel',
        verification: 'delete'
      },
      isCollapsed: false,
      calculations_collapsed: false
    };
  },
  watch: {
    clients: function () {
      this.items = this.clients;
    },
    'edit_template.client_id': function () {
      if (this.clients.length) {
        if (this.edit_template.client_id) {
          for (const i in this.clients) {
            if (this.clients[i].id == this.edit_template.client_id) {
              this.item = this.clients[i];
            }
          }
        }
      }
    },
    item: function (val) {
      if (val) {
        this.edit_template.client_id = val.id;
        if (this.edit_template.contract_status != 'done') {
          for (var i = 0; i < this.clients.length; i++) {
            if (this.clients[i].id == val.id) {
              for (var key in this.clients[i]) {
                if (key != 'id' && key != 'created_at' && key != 'updated_at' && key != 'active') {
                  let field_exists = false;
                  for (var j = 0; j < this.edit_template.fixed_variables.length; j++) {
                    if (this.edit_template.fixed_variables[j].name == `[[client_${key}]]`) {
                      field_exists = true;
                      this.edit_template.fixed_variables[j].value = this.clients[i][key];
                    }
                  }
                  if (!field_exists) {
                    const variableKey = `[[client_${key}]]`;
                    this.edit_template.fixed_variables.push({
                      name: variableKey,
                      value: this.clients[i][key],
                      type: 'fixed'
                    });
                  }
                }
              }
            }
          }
          for (var i = 0; i < this.clients.length; i++) {
            if (this.clients[i].id == val.id) {
              for (var j = 0; j < this.edit_template.fixed_variables.length; j++) {
                for (var key in this.clients[i]) {
                  if (key != 'id' && key != 'created_at' && key != 'updated_at' && key != 'active') {
                    if (this.edit_template.fixed_variables[j].name == `[[client_${key}]]`) {
                      this.edit_template.fixed_variables[j].value = this.clients[i][key];
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    edit_template: {
      handler: function (val) {
        this.contract_saved = false;
        if (this.contract_updated) {
          this.contract_saved = true;
          this.contract_updated = false;
        }
      },
      deep: true
    },
    deleted_file: function (val) {
      if (this.deleted_file.status == 'success') {
        this.showSuccessMsg({ title: 'File delete status', message: this.deleted_file.data.message });
        for (let i = 0; i < this.contract_files.length; i++) {
          if (this.contract_files[i].id == this.deleted_file.data.file.id) {
            this.contract_files.splice(i, 1);
          }
        }
      }
      if (this.deleted_file.status == 'error') {
        this.showErrorMsg({ title: 'File delete status', message: this.deleted_file.data.message });
      }
    },
    permissions: 'permissionsLoaded'
  },
  computed: {
    ...mapGetters('Clients', ['clients']),
    ...mapGetters('Templates', ['deleted_file']),
    ...mapGetters('Auth', ['permissions'])
  },
  methods: {
    ...mapActions('Clients', [
      'GET_CLIENTS_LIST',
      'SEARCH_CLIENTS'
    ]),
    ...mapActions('Templates', [
      'UPDATE_TEMPLATE',
      'DELETE_TEMPLATE_VARIABLE',
      'DELETE_FILE',
      'DELETE_TEMPLATE_CALCULATION_ROW'
    ]),
    getLabel(item) {
      if (item) {
        return item.title;
      }
      return '';
    },
    updateItems(text) {
      this.SEARCH_CLIENTS(text).then((response) => {
        this.items = response.data.data;
      }, (err) => {

      });
    },
    permissionsLoaded() {
      for (const i in this.permissions) {
        if (this.permissions[i] == 'edit-contracts-with-status-done') {
          this.permission_change_done_status = true;
        }
      }
    },
    updateVariablesList() {
      this.edit_template.defined_variables.map((variable, index) => {
        variable.order = index + 1;
      });
    },
    updateCalculationsList() {
      this.edit_template.calculations_table.map((row, index) => {
        row.order = index + 1;
      });
    },
    addVariable() {
      this.edit_template.defined_variables.push({
        name: '',
        value: '',
        type: 'input',
        order: '0'
      });
    },
    addCalculation() {
      if (this.edit_template.calculations_table.length) {
        this.edit_template.calculations_table.push({
          main: false,
          name: '',
          description: '',
          quantity: '',
          unit: this.edit_template.calculations_table[this.edit_template.calculations_table.length - 1].unit,
          price: this.edit_template.calculations_table[this.edit_template.calculations_table.length - 1].price,
          order: this.edit_template.calculations_table[this.edit_template.calculations_table.length - 1].order + 1,
        });
      } else {
        this.edit_template.calculations_table.push({
          main: false,
          name: '',
          description: '',
          quantity: '',
          unit: '',
          price: '',
          order: 1
        });
      }
    },
    removeVariable(variable) {
      if (variable.id) {
        this.DELETE_TEMPLATE_VARIABLE(variable.id);
      }
      this.edit_template.defined_variables.splice(this.edit_template.defined_variables.indexOf(variable), 1);
    },
    removeCalculation(row) {
      if (row.id) {
        this.DELETE_TEMPLATE_CALCULATION_ROW(row.id);
      }
      this.edit_template.calculations_table.splice(this.edit_template.calculations_table.indexOf(row), 1);
    },
    updateTemplate() {
      if (this.edit_template.contract_date) {
        this.edit_template.contract_date = moment(this.edit_template.contract_date).format('YYYY-MM-DD');
      } else {
        this.edit_template.contract_date = '';
      }
      if (this.edit_template.defined_variables.length > 0) {
        for (var i = 0; i < this.edit_template.defined_variables.length; i++) {
          if (!this.edit_template.defined_variables[i].name) {
            this.showErrorMsg({ title: 'Variables', message: 'Variables name field cannot be empty!' });
            return;
          }
        }
      }
      for (var i = 0; i < this.edit_template.default_variables.length; i++) {
        if (this.edit_template.default_variables[i].name == '[[contract_name]]') {
          if (this.edit_template.contract_name) {
            this.edit_template.default_variables[i].value = this.edit_template.contract_name;
          } else {
            this.edit_template.default_variables[i].value = '';
          }
        }
        if (this.edit_template.default_variables[i].name == '[[contract_place]]') {
          if (this.edit_template.contract_place) {
            this.edit_template.default_variables[i].value = this.edit_template.contract_place;
          } else {
            this.edit_template.default_variables[i].value = 'Contract place';
          }
        }
        if (this.edit_template.default_variables[i].name == '[[contract_number]]') {
          if (this.edit_template.contract_number) {
            this.edit_template.default_variables[i].value = this.edit_template.contract_number;
          } else {
            this.edit_template.default_variables[i].value = 'Contract number';
          }
        }
        if (this.edit_template.default_variables[i].name == '[[contract_date]]') {
          if (this.edit_template.contract_date) {
            this.edit_template.default_variables[i].value = this.edit_template.contract_date;
          } else {
            this.edit_template.default_variables[i].value = 'Date when contract will be signed';
          }
        }
        if (this.edit_template.default_variables[i].name == '[[apply_person]]') {
          if (this.edit_template.apply_person) {
            this.edit_template.default_variables[i].value = this.edit_template.apply_person;
          } else {
            this.edit_template.default_variables[i].value = 'Apply signatory person';
          }
        }
        if (this.edit_template.default_variables[i].name == '[[apply_position]]') {
          if (this.edit_template.apply_position) {
            this.edit_template.default_variables[i].value = this.edit_template.apply_position;
          } else {
            this.edit_template.default_variables[i].value = 'Apply signatory person position';
          }
        }
        if (this.edit_template.default_variables[i].name == '[[payment_due_date]]') {
          if (this.edit_template.payment_due_date) {
            this.edit_template.default_variables[i].value = this.edit_template.payment_due_date;
          } else {
            this.edit_template.default_variables[i].value = 'Invoice payment due date';
          }
        }
        if (this.edit_template.default_variables[i].name == '[[discount_percentage]]') {
          if (this.edit_template.discount_percentage) {
            this.edit_template.default_variables[i].value = this.edit_template.discount_percentage;
          } else {
            this.edit_template.default_variables[i].value = 'Discount (X%)';
          }
        }
      }
      //                this.edit_template.contract_content = CKEDITOR.instances.editor1.getData();
      let content = this.editor_content;
      if (content) {
        const matches = content.match(/\[\[([^[\n]*?)\]\](?!\<\/span\>)/g);

        if (matches) {
          for (var i = 0; i < matches.length; i++) {
            let variable = matches[i].replace(/[\[\]]/g, '');
            variable = variable.replace(/\+/g, '\\+');
            content = content.replace(new RegExp(`\\[\\[(${variable})\\]\\](?!\<\/span\>)`, 'gi'), `<span style="background-color:#c7d0e0">${matches[i]}</span>`);
          }
        }
      }
      this.editor_content = content;
      this.edit_template.contract_content = this.editor_content;
      this.errors = false;
      this.UPDATE_TEMPLATE(this.edit_template).then((response) => {
        this.showSuccessMsg({ title: 'Template update status', message: response.data.data.message });
        this.contract_updated = true;
        this.getTemplateData();
        if (this.edit_template.contract_status == 'done') {
          this.contract_editable = false;
        }
        this.contract_saved = true;
      }, (err) => {
        this.errors = err.response.data.data;
        for (const i in this.errors) {
          this.showErrorMsg({ title: 'Template update status', message: this.errors[i] });
        }
        console.log(err);
      });
    },
    deleteFile(file) {
      const vm = this;
      this.$dialog.confirm(`Delete file - ${file.file_name}?`, this.confirmation_options)
        .then(() => {
          vm.DELETE_FILE(file.id);
        })
        .catch(() => {

        });
    },
    getTemplateData() {
      Backend.get('/api/get_template', { params: { id: this.$route.params.id } }).then((response) => {
        this.edit_template.contract_id = response.data.data.id;
        this.edit_template.contract_name = response.data.data.contract_name;
        this.edit_template.contract_place = response.data.data.contract_place;
        this.edit_template.contract_date = response.data.data.contract_date;
        this.edit_template.contract_number = response.data.data.contract_number;
        this.edit_template.client_id = response.data.data.client_id;
        this.edit_template.contract_status = response.data.data.contract_status;
        this.edit_template.apply_person = response.data.data.apply_person;
        this.edit_template.apply_position = response.data.data.apply_position;
        this.edit_template.footer = response.data.data.footer;
        this.edit_template.document_type = response.data.data.document_type;
        this.edit_template.payment_due_date = response.data.data.payment_due_date;
        this.edit_template.paid_advance_payment = response.data.data.paid_advance_payment;
        this.edit_template.advance_payment_enabled = response.data.data.advance_payment_enabled;
        this.edit_template.discount_enabled = response.data.data.discount_enabled;
        this.edit_template.discount_percentage = response.data.data.discount_percentage;
        this.edit_template.discount_amount = response.data.data.discount_amount;
        this.edit_template.vat_enabled = response.data.data.vat_enabled;
        this.edit_template.advanced_invoice = response.data.data.advanced_invoice;
        //                    this.edit_template.contract_type = response.data.data.contract_type;
        this.contract_files = response.data.data.files;
        this.edit_template.calculations_table = response.data.data.calculations.sort((a, b) => { return (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0); });
        this.url = `/api/upload_appendix?contract_id=${this.edit_template.contract_id}`;
        if (response.data.data.contract_status == 'done') {
          this.contract_editable = false;
        }

        const defined_variables = [];
        const default_variables = [];
        const fixed_variables = [];
        for (var i = 0; i < response.data.data.variables.length; i++) {
          if (response.data.data.variables[i].type == 'input') {
            defined_variables.push(response.data.data.variables[i]);
          }
          if (response.data.data.variables[i].type == 'fixed') {
            fixed_variables.push(response.data.data.variables[i]);
            if (response.data.data.variables[i].name == '[[calculations_quantity_sum]]') {
              if (isNaN(parseInt(response.data.data.variables[i].value))) {
                this.calculations.quantity_sum = 0;
              } else {
                this.calculations.quantity_sum = response.data.data.variables[i].value;
              }
            }
            if (response.data.data.variables[i].name == '[[price_without_vat]]') {
              if (isNaN(parseInt(response.data.data.variables[i].value))) {
                this.calculations.price_without_vat = 0;
              } else {
                this.calculations.price_without_vat = response.data.data.variables[i].value;
              }
            }
          }
          if (response.data.data.variables[i].type == 'default') {
            default_variables.push(response.data.data.variables[i]);
          }
        }

        this.edit_template.defined_variables = defined_variables.sort((a, b) => { return (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0); });
        this.edit_template.default_variables = default_variables;
        this.edit_template.fixed_variables = fixed_variables;
        //                    if (CKEDITOR.instances['editor1']) {
        //                        CKEDITOR.instances['editor1'].destroy();
        //                    }
        let content = response.data.data.contract_content;
        if (content) {
          const matches = content.match(/\[\[([^[\n]*?)\]\](?!\<\/span\>)/g);

          if (matches) {
            for (var i = 0; i < matches.length; i++) {
              let variable = matches[i].replace(/[\[\]]/g, '');
              variable = variable.replace(/\+/g, '\\+');
              content = content.replace(new RegExp(`\\[\\[(${variable})\\]\\](?!\<\/span\>)`, 'gi'), `<span style="background-color:#c7d0e0">${matches[i]}</span>`);
            }
          }
        }
        this.editor_content = content;
        //                    if(this.edit_template.contract_type == 'system'){
        //                        CKEDITOR.replace('editor1');
        //                        CKEDITOR.instances.editor1.setData(response.data.data.contract_content);
        //                    CKEDITOR.config.readOnly = true;
        //                        CKEDITOR.editor.setReadOnly;
        //                    }
        this.contract_updated = true;
        this.permissionsLoaded();
      }, (err) => {
        console.log(err);
      });
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
    this.GET_CLIENTS_LIST();
    this.getTemplateData();
    //            this.$watch(
    //                () => {
    //                    return this.$refs.upload.active;
    //                },
    //                (val) => {
    //                    if(this.$refs.upload.active == false){
    //                        this.updateContract();
    //                    }
    //                }
    //            )
  }
};
</script>

<style lang="scss" scope>
    .z-1 {
        z-index: 1;
    }
    .z-0 {
        z-index: 0;
    }
    .action {
        margin-left: 5px;

        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }

    .dg-btn--ok {
        color: #fff;
        background-color: #20a8d8;
        border-color: #20a8d8;
        border-radius: var(--border-radius);
    }

    .dg-btn--ok:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #1985ac;
        border-color: #187fa3;

    }

    .dg-btn--ok:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--ok:disabled,
    .dg-btn--ok.is-disabled {
        opacity: .5;
    }

    .dg-btn--cancel {
        color: #263238;
        background-color: #fff;
        border-color: #b0bec5;
        border-radius: var(--border-radius);
    }

    .dg-btn--cancel:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #e6e5e5;
        border-color: #8da1ab;

    }

    .dg-btn--cancel:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--cancel:disabled,
    .dg-btn--cancel.is-disabled {
        opacity: .5;
    }
    .footer-switch {
        padding-top: 2px;
        padding-left: 10px;
    }
    .ghost{
        opacity: 0.5;
        background: #C8EBFB;
    }
    .calculationsTableMainRow {
        background-color: #e6e6e6;
    }
    .calculationsTableRow {
        background-color: #ffffff;
    }
    .error-class {
        border-color: red;
    }
    .v-autocomplete-input {
        display: block;
        width: 100%;
        padding: 0.5rem 0.75rem;
        font-size: 0.875rem;
        line-height: 1.25;
        color: #607d8b;
        background-color: #fff;
        background-image: none;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0;
    }
    .v-autocomplete-input-disabled {
        display: block;
        width: 100%;
        padding: 0.5rem 0.75rem;
        font-size: 0.875rem;
        line-height: 1.25;
        color: #607d8b;
        background-color: #cfd8dc;
        background-image: none;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0;
    }
    .v-autocomplete-list {
        width: 100%;
        text-align: left;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0;
        position: absolute;
        /*border-top: none;*/
        max-height: 200px;
        overflow-y: auto;
        /*border-bottom: 1px solid #157977;*/
    }
    .v-autocomplete-list-item {
        cursor: pointer;
        padding: 5px;
        border: 1px solid rgba(0, 0, 0, 0.15);
    }
    .v-autocomplete-list-item:hover {
        background-color: #e6e6e6;
    }
</style>
<style>
    .edit-template-date-picker {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;
        padding: 0.38rem 0.75rem;
    }
    input[type="text"]:disabled{
        background-color: #cfd8dc;
        border: 1px solid #cfd8dc;
    }
</style>
